// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const CUSTOMERS_QUERY = gql`
  query Customers {
    customers {
      name
    }
  }
`;
